"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
require("./CTAButtons.scss");
var _Video = _interopRequireDefault(require("../Video/Video"));
var _Button = _interopRequireDefault(require("../Button/Button"));
var _CTAWithHeaderMethods = require("../CTAWithHeader/CTAWithHeaderMethods");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const CTAButtons = _ref => {
  let {
    alignment,
    variant,
    buttons,
    contentfulId
  } = _ref;
  const buttonsClass = {
    light: {
      primary: "ter-button--primary--1",
      secondary: "ter-button--primary--2"
    },
    dark: {
      primary: "ter-button--secondary--1",
      secondary: "ter-button--secondary--2"
    }
  };
  const buttonsVariants = buttonsClass[variant || "light"];
  return /*#__PURE__*/_react.default.createElement("div", {
    className: `cta-buttons-container ${alignment || ""}`,
    "data-sb-object-id": contentfulId
  }, buttons?.length && /*#__PURE__*/_react.default.createElement("div", {
    className: "cta-buttons",
    "data-sb-field-path": "ctaButtons"
  }, buttons.map((button, index) => {
    const buttonUrl = (0, _CTAWithHeaderMethods.checkForAnchors)(button);
    if (button?.text && !button?.video) {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
        key: `cta-button-${variant ? variant + "-" : ""}${index}`
      }, /*#__PURE__*/_react.default.createElement(_Button.default, {
        contentfulId: button?.contentfulId,
        key: `button-${variant ? variant + "-" : ""}${index}`,
        className: (index + 1) % 2 !== 0 ? buttonsVariants?.primary : buttonsVariants?.secondary,
        url: buttonUrl,
        onClick: button?.onClick
      }, button.text));
    } else {
      return renderButtonWithVideo(button, index, buttonsVariants, variant);
    }
  })));
};
var _default = CTAButtons;
exports.default = _default;
const renderButtonWithVideo = (button, index, buttonsVariants, variant) => {
  const [override, setOverride] = (0, _react.useState)(false);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Button.default, {
    contentfulId: button?.contentfulId,
    key: `button-${variant ? variant + "-" : ""}${index}`,
    className: (index + 1) % 2 !== 0 ? buttonsVariants?.primary : buttonsVariants?.secondary,
    url: button?.url,
    video: button?.video,
    override: override,
    setOverride: setOverride,
    VideoComponent: _Video.default
  }, button?.text));
};